import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import addressesActionCreators from '../../store/addresses/action-creators';
import myDepartment from '../../store/my-department/action-creators/index';
import phonesActionCreators from '../../store/phones/action-creators';
import AddressAdd from '../common/addresses/AddressAdd';
import AddressEdit from '../common/addresses/AddressEdit';
import AddressList from '../common/addresses/AddressList';
import EditActionButton from '../common/EditActionButton';
import FormattedProperty from '../common/FormattedProperty';
import ListActionSubheader from '../common/ListActionSubheader';
import PhoneAdd from '../common/phones/PhoneAdd';
import PhoneEdit from '../common/phones/PhoneEdit';
import PhoneList from '../common/phones/PhoneList';
import MyDepartmentEdit from './MyDepartmentEdit';
import Modal from '../../../shared/ui/Modal';

class MyDepartmentDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { isEditingDepartment: false };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    this.props.loadMyDepartment();
  }

  // ----------------------
  // Handlers
  // ----------------------

  onCloseEditDepartment() {
    this.setState({ isEditingDepartment: false });
  }

  onEditDepartment() {
    this.setState({ isEditingDepartment: true });
  }

  onCloseEditDepartmentPhones() {
    this.props.closeMyDepartmentEditingPhones();
  }

  onCloseEditDepartmentAddresses() {
    this.props.closeMyDepartmentEditingAddresses();
  }

  onSaveAddAddress(addressFormData) {
    const formData = {
      addresses: this.props.department.getAddressesWithAdded(addressFormData),
    };
    this.props.updateDepartmentAddresses(formData);
  }

  onSaveAddPhone(phoneFormData) {
    const formData = {
      phones: this.props.department.getPhonesWithAdded(phoneFormData),
    };
    this.props.updateDepartmentPhones(formData);
  }

  onSaveEditAddress(addressFormData) {
    const formData = {
      addresses: this.props.department.getAddressesWithUpdated(
        this.props.isEditingAddress,
        addressFormData,
      ),
    };
    this.props.updateDepartmentAddresses(formData);
  }

  onSaveEditDetails(departmentFormData) {
    this.props.updateDepartmentDetails(departmentFormData).then(() => {
      this.onCloseEditDepartment();
    });
  }

  onSaveEditPhone(phoneFormData) {
    const formData = {
      phones: this.props.department.getPhonesWithUpdated(
        this.props.isEditingPhone,
        phoneFormData,
      ),
    };
    this.props.updateDepartmentPhones(formData);
  }

  // ----------------------
  // Computed
  // ----------------------

  get addresses() {
    return this.props.department.addresses;
  }

  get phones() {
    return this.props.department.getFormattedPhones();
  }

  get isLoading() {
    return this.props.isLoading.includes('updateMyDepartment');
  }

  get isAddEditEnabled() {
    return this.props.userContext.hasScope(['depadmin', 'admin'])
  }

  // ----------------------
  // Methods
  // ----------------------

  setDefaultAddress(index) {
    const formData = {
      addresses: this.props.department.getAddressesWithDefault(index),
      userGuid: this.props.department,
    };
    this.props.updateDepartmentAddresses(formData);
  }

  setDefaultPhone(index) {
    const formData = {
      phones: this.props.department.getPhonesWithDefault(index),
      userGuid: this.props.department,
    };
    this.props.updateDepartmentPhones(formData);
  }

  deleteAddress(index) {
    const formData = {
      addresses: this.props.department.getAddressesWithDeleted(index),
      userGuid: this.props.department,
    };
    this.props.updateDepartmentAddresses(formData);
  }

  deletePhone(index) {
    const formData = {
      phones: this.props.department.getPhonesWithDeleted(index),
      userGuid: this.props.department,
    };
    this.props.updateDepartmentPhones(formData);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <div>
          {this.props.department && (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">My Department</h4>
                {this.props.userContext.hasScope(['depadmin', 'admin']) && (
                  <EditActionButton
                    label="Details"
                    onEdit={() => this.onEditDepartment()}
                  />
                )}
              </div>
              <div className="app-content profile">
                <ListActionSubheader title="Details" />
                <div className="card profile-details">
                  <div className="profile-details-item">
                    <FormattedProperty
                      label="Name"
                      value={this.props.department.name}
                    />
                  </div>
                  <div className="profile-details-item">
                    <FormattedProperty
                      label="Time Zone"
                      value={this.props.department.getTimezoneName()}
                    />
                  </div>
                </div>
                <PhoneList
                  canAddEdit={this.isAddEditEnabled}
                  onAdd={() => this.props.addPhone()}
                  onEdit={index => this.props.editPhone(index)}
                  phones={this.phones}
                  onDelete={index => this.deletePhone(index)}
                  onSetDefault={index => this.setDefaultPhone(index)}
                />
                <AddressList
                  canAddEdit={this.isAddEditEnabled}
                  onAdd={() => this.props.addAddress()}
                  onEdit={index => this.props.editAddress(index)}
                  addresses={this.addresses}
                  onDelete={index => this.deleteAddress(index)}
                  onSetDefault={index => this.setDefaultAddress(index)}
                />

                <Modal
                  isOpen={this.props.isAddingPhone}
                  onClose={() => this.props.closeAddPhone()}
                  title={`Add Phone for ${this.props.department.name}`}
                >
                  <PhoneAdd
                    onSave={formData => this.onSaveAddPhone(formData)}
                  />
                </Modal>

                <Modal
                  isOpen={this.props.isEditingPhone !== -1}
                  title={`Edit Phone for ${this.props.department.name}`}
                  onClose={() => this.props.closeEditPhone()}
                >
                  <PhoneEdit
                    phone={
                      this.props.department.phones[this.props.isEditingPhone]
                    }
                    onSave={formData => this.onSaveEditPhone(formData)}
                  />
                </Modal>

                <Modal
                  isOpen={this.props.isAddingAddress}
                  onClose={() => this.props.closeAddAddress()}
                  title={`Add Address for ${this.props.department.name}`}
                >
                  <AddressAdd
                    onSave={formData => this.onSaveAddAddress(formData)}
                  />
                </Modal>

                <Modal
                  isOpen={this.props.isEditingAddress !== -1}
                  onClose={() => this.props.closeEditAddress()}
                  title={`Edit Address for ${this.props.department.name}`}
                >
                  <AddressEdit
                    address={this.addresses[this.props.isEditingAddress]}
                    onSave={formData => this.onSaveEditAddress(formData)}
                  />
                </Modal>

                <Modal
                  isOpen={this.state.isEditingDepartment}
                  onClose={() => this.onCloseEditDepartment()}
                  title="Edit my department"
                >
                  <MyDepartmentEdit
                    department={this.props.department}
                    onSave={formData => this.onSaveEditDetails(formData)}
                  />
                </Modal>
              </div>
            </Fragment>
          )}
        </div>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    department: state.myDepartment.department,
    isAddingAddress: state.addresses.isAddingAddress,
    isAddingPhone: state.phones.isAddingPhone,
    isEditingAddress: state.addresses.isEditingAddress,
    isEditingPhone: state.phones.isEditingPhone,
    isLoading: state.myDepartment.isLoading,
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addPhone: () => {
      return dispatch(phonesActionCreators.addPhone());
    },
    addAddress: () => {
      return dispatch(addressesActionCreators.addAddress());
    },
    closeAddAddress: () => {
      return dispatch(addressesActionCreators.closeAddAddress());
    },
    closeAddPhone: () => {
      return dispatch(phonesActionCreators.closeAddPhone());
    },
    closeEditAddress: () => {
      return dispatch(addressesActionCreators.closeEditAddress());
    },
    closeEditPhone: () => {
      return dispatch(phonesActionCreators.closeEditPhone());
    },
    editAddress: (index) => {
      return dispatch(addressesActionCreators.editAddress(index));
    },
    editPhone: (index) => {
      return dispatch(phonesActionCreators.editPhone(index));
    },
    loadMyDepartment: () => {
      return dispatch(myDepartment.loadMyDepartment());
    },
    updateDepartmentAddresses: (formData) => {
      return dispatch(myDepartment.updateMyDepartmentAddresses(formData));
    },
    updateDepartmentDetails: (formData) => {
      return dispatch(myDepartment.updateMyDepartment(formData));
    },
    updateDepartmentPhones: (formData) => {
      return dispatch(myDepartment.updateMyDepartmentPhones(formData));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyDepartmentDetail));
